import { createSlice } from "@reduxjs/toolkit";
import { getMediaVideo } from "./mediaVideoApi";

// Slice for  Media state
const mediaSlice = createSlice({
  name: "mediaVideo",
  initialState: {
    mediaVideo: [],
    loading: false,
    error: null,
    dataLimit: 0,
    currentPage: 0,
    totalPages: 0,
    totalMediaVideo: 0,
  },
  extraReducers: (builder) => {
    builder.addCase(getMediaVideo.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(getMediaVideo.fulfilled, (state, action) => {
      state.loading = false;
      state.mediaVideo = action.payload;
      state.dataLimit = action.payload.meta.limit;
      state.currentPage = action.payload.meta.page;
      state.totalPages = action.payload.meta.totalPages;
      state.totalMediaVideo = action.payload.meta.total;
    });
    builder.addCase(getMediaVideo.rejected, (state, action) => {
      state.loading = false;
    });
  },
});

export default mediaSlice.reducer;
